import type { BookingInquiryAdminGroupNames } from '@models/BookingInquiry';
import type { BookingInquiryLog, BookingInquiryLogField } from '@models/next/BookingInquiryLog';
import { orderBy } from 'lodash-es';

export const bookingInquiryAdminGroupNameToFields: Record<
  BookingInquiryAdminGroupNames,
  BookingInquiryLogField[]
> = {
  shipper: ['shipper'],
  receiver: ['receiver', 'preferred_arrival_date'],
  consignee: ['consignee'],
  customerNo: ['customer_no'],
  cargos: ['has_pickups', 'pickup_date', 'move_in_date', 'cargos'],
  miscInfo: ['trade_condition', 'use_trading_agency', 'trading_agency_payer', 'use_rcep'],
  specialNote: ['special_note'],
  routePlan: ['route_plan'],
};

export interface BookingInquiryChangeLogGroup {
  groupId: string;
  groupName: BookingInquiryAdminGroupNames;
  changeLogs: BookingInquiryLog[];
  hasRead: boolean;
  createdAt: string;
}

export const mapBookingInquiryChangeLogsToBookingInquiryChangeLogGroups = (
  values: BookingInquiryLog[],
): BookingInquiryChangeLogGroup[] => {
  const groups: BookingInquiryChangeLogGroup[] = [];

  const sortedValues = orderBy(values, ['created_at'], 'desc');

  for (const log of sortedValues) {
    let currentGroup = groups.find((g) => g.groupId === log.group_id);

    if (!currentGroup) {
      const groupName = Object.keys(bookingInquiryAdminGroupNameToFields).find((name) =>
        bookingInquiryAdminGroupNameToFields[name as BookingInquiryAdminGroupNames].includes(
          log.edited_field,
        ),
      ) as BookingInquiryAdminGroupNames;

      if (!groupName) {
        throw new Error(
          `groupName for ${JSON.stringify(
            log.edited_field,
          )} is not found in bookingInquiryAdminGroupNameToFields. Did you add a new field?`,
        );
      }

      currentGroup = {
        groupId: log.group_id,
        groupName,
        changeLogs: [],
        hasRead: log.has_read,
        createdAt: log.created_at,
      };

      groups.push(currentGroup);
    }

    currentGroup.changeLogs.push(log);
  }

  return groups;
};
